import BaseMenu from 'System/UI/Menu/BaseMenu';
import RelativePositionComponent from 'Component/Render/RelativePosition';
import Point from 'Utility/Point';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import { GameObjectEvent } from 'GameObject/GameObject';
import { UIActions } from 'State/UI/UIActions';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { ContentEndLevelPopupLayout } from 'Layouts/LevelPopup/ContentEndLevelPopupLayout';
import { PopupID } from 'State/UI/PopupID';
import BaseUISystem from 'System/UI/BaseUISystem';

export class ContentEndLevelPopup extends BaseMenu {
    private layout: GLayout<ContentEndLevelPopupLayout>;

    constructor(uiSystem: BaseUISystem) {
        super(PopupID.CONTENT_END_LEVEL_POPUP, uiSystem, false);
    }

    public onShow(): void {
        super.onShow();
        this.layout = getLayout(ContentEndLevelPopupLayout);
        this.layout.root.addComponent(RelativePositionComponent);
        this.layout.root.getComponent(RelativePositionComponent).relativePosition = new Point(0.5, 0.5);
        this.element.addChild(this.layout.root);

        const { closeButton, playButton } = this.layout;
        [closeButton, playButton].forEach(o => applyDefaultButtonAnimation(o));
        closeButton.once(GameObjectEvent.SELECTED, () => UIActions.hidePopup(this.name));
        playButton.once(GameObjectEvent.SELECTED, () => UIActions.hidePopup(this.name));
    }
}
